import { type IMenuItemProps } from 'shared/ui'
import { AnalyticsPath } from 'entities/ExportRouters'

export const AnalyticsKey = 'Analytics'

export enum EnumMenuAnalyticsItemsKey {
  overall = 'overall',
  conversations = 'conversations',
  messages = 'messages',
  calls = 'calls',
  performance = 'performance',
  contacts = 'contacts',
  conversions = 'conversions',
  creditUsage = 'credit_usage',
  creditUsage_all = 'credit_usage_all',
  creditUsage_sources = 'credit_usage_sources',
}

export const menuItems: IMenuItemProps<EnumMenuAnalyticsItemsKey>[] = [
  {
    key: EnumMenuAnalyticsItemsKey.overall,
    type: 'nav',
    to: AnalyticsPath.overall,
    fullPath: true,
    label: 'Overall',
    icon: 'analytics',
  },
  {
    key: EnumMenuAnalyticsItemsKey.conversations,
    type: 'nav',
    to: AnalyticsPath.conversations,
    fullPath: true,
    label: 'Conversations',
    icon: 'conversation',
  },
  {
    key: EnumMenuAnalyticsItemsKey.messages,
    type: 'nav',
    to: AnalyticsPath.messages,
    fullPath: true,
    label: 'Messages',
    icon: 'messageTextCircle02',
  },
  {
    key: EnumMenuAnalyticsItemsKey.calls,
    type: 'nav',
    to: AnalyticsPath.calls,
    fullPath: true,
    label: 'Calls',
    icon: 'phone',
  },
  {
    key: EnumMenuAnalyticsItemsKey.performance,
    type: 'nav',
    to: AnalyticsPath.performance,
    fullPath: true,
    label: 'Performance',
    icon: 'limit',
  },
  {
    key: EnumMenuAnalyticsItemsKey.contacts,
    type: 'nav',
    to: AnalyticsPath.contacts,
    fullPath: true,
    label: 'Contacts',
    icon: 'users',
  },
  {
    key: EnumMenuAnalyticsItemsKey.conversions,
    type: 'nav',
    to: AnalyticsPath.conversions,
    fullPath: true,
    label: 'Conversions',
    icon: 'dollar',
  },
  {
    key: EnumMenuAnalyticsItemsKey.creditUsage,
    type: 'sub',
    label: 'Credit usage',
    icon: 'credits',
    items: [
      {
        key: EnumMenuAnalyticsItemsKey.creditUsage_all,
        type: 'nav',
        to: AnalyticsPath.creditUsageAll,
        fullPath: true,
        label: 'Overview',
      },
      {
        key: EnumMenuAnalyticsItemsKey.creditUsage_sources,
        type: 'nav',
        to: AnalyticsPath.creditUsageSources,
        fullPath: true,
        label: 'Sources',
      },
    ],
  },
]
